import { i18nFn } from '../../../types';
import { buildScoreReportPayload } from '../helpers/buildScoreReportPayload';
import { mapToClientInfoData } from '../helpers/mapToClientInfoData';
import { mapToCreditScoreData } from '../helpers/mapToCreditScoreData';
import { IClientInfoData } from '../subcomponents/score-dashboard/subcomponents/score-info/types';
import { ICreditScoreData } from '../subcomponents/score-dashboard/subcomponents/score-result/types';
import { IScoreReportPayload } from '../types/api';
import { getLatestScoreByDocument } from './getLatestScoreByDocument';
import { getScoreSummary } from './getScoreSummary';
import { buildIndicatorsPayload, saveConsultationIndicators } from './saveConsultationIndicators';

export interface GetCreditScoreDataOptions {
  document: string;
  refresh?: boolean;
  idempotencyKey?: string;
  /**
   * Quando true (fluxo real de consulta do Sankhya Score), persiste os
   * indicadores + flags no score-api. Falso no modo detalhe/somente-leitura.
   */
  captureIndicators?: boolean;
}

export interface GetCreditScoreDataResult {
  creditScoreData?: ICreditScoreData;
  clientInfoData?: IClientInfoData;
  reportPayload?: IScoreReportPayload;
  scoreId?: string;
  summary?: any;
}

export async function getCreditScoreData(options: GetCreditScoreDataOptions, i18n: i18nFn): Promise<GetCreditScoreDataResult> {
  const { document, refresh = false, idempotencyKey, captureIndicators = false } = options;

  const results = await Promise.allSettled([
    getLatestScoreByDocument({ document, refresh, idempotencyKey }),
    getScoreSummary(document),
  ]);

  const scoreResponse = results[0].status === 'fulfilled' ? results[0].value : null;
  const summary = results[1].status === 'fulfilled' ? results[1].value : null;

  if (captureIndicators && scoreResponse?.score?.scoreId && summary) {
    // Best-effort: não bloqueia nem quebra a exibição do score se falhar.
    try {
      await saveConsultationIndicators(document, scoreResponse.score.scoreId, buildIndicatorsPayload(summary));
    } catch (error) {
      console.warn('[fin-bank-credit-score] Falha ao salvar indicadores da consulta:', error);
    }
  }

  return {
    creditScoreData: scoreResponse ? mapToCreditScoreData({ score: scoreResponse, summary }, i18n) : undefined,
    clientInfoData: scoreResponse ? mapToClientInfoData(scoreResponse, i18n) : undefined,
    reportPayload: scoreResponse ? buildScoreReportPayload(scoreResponse) : undefined,
    scoreId: scoreResponse?.score?.scoreId,
    summary,
  };
}
